import { useRouter } from 'next/navigation';

import { useAppRouter as useCorgiAppRouter } from 'corgi/common/hooks/app-router';

export const useAppRouter = () => useCorgiAppRouter(useRouter());
